import styled from 'styled-components';

export const Button = styled.button`
  width: 100%;
  height: 30px;
  border-radius: 5px;
  border: none;
  background: #515f75;
  font-size: 13px;
  color: #ffffff;

  &:disabled {
    opacity: 0.7;
  }
`;
